import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>Sudoku Master &copy; 2026. Built with React.</p>
    </footer>
  );
}

export default Footer;
